'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var DEFAULT_COLORS = exports.DEFAULT_COLORS = ['#4B9BFF', '#FFB46E', '#FF5F5F', '#50D2A0', '#FF73C3', '#9CE269', '#AF78FF', '#FFD76E', '#5FC8FF'];

var DEFAULT_GRID_OBJECT = exports.DEFAULT_GRID_OBJECT = {
	x: {
		show: true
	},
	y: {
		show: true
	}
};

var DEFAULT_LINE_CLASSES = exports.DEFAULT_LINE_CLASSES = ['bb-line-dashed-2-2', 'bb-line-dashed-2-3', 'bb-line-dashed-2-4', 'bb-line-dashed-3-2', 'bb-line-dashed-3-3', 'bb-line-dashed-3-4', 'bb-line-dashed-4-2', 'bb-line-dashed-4-3', 'bb-line-dashed-4-4'];

var DEFAULT_TILES = exports.DEFAULT_TILES = ['circles', 'diagonal-left-large', 'diagonal-left-small', 'diagonal-right-large', 'diagonal-right-small', 'horizontal-large', 'horizontal-small', 'vertical-large', 'vertical-small'];

var DEFAULT_POINT_PATTERNS = exports.DEFAULT_POINT_PATTERNS = ['circle', 'rectangle', '<polygon points="2.5 0 0 5 5 5"></polygon>', '<polygon points="2.5 0 0 2.5 2.5 5 5 2.5"></polygon>', '<polygon points="0 0 2.5 5 5 0"></polygon>', '<path d="M5,5 a1,1 0 1,1 5,0">', '<path d="M0,0 a1,1 0 0,0 5,0">', '<rect width="5" height="2.5"></rect>', '<rect width="2.5" height="5"></rect>'];
//# sourceMappingURL=config.js.map